import React, { useState, useEffect } from "react";
import { Descriptions, Button, Radio } from "antd";
import DetailedScheduleAssignment from './DetailedScheduleAssignment.js';
import Widget from "../../Theme/Widget/index.js";
import dayjs from 'dayjs';

const DetailedScheduleTour = (props) => {

  const [editType, setEditType] = useState(props.detailedSchedule.approved != 1 ? 'tourTimes' : 'myTourComment')
  const [editAssignType, setEditAssignType] = useState('assignTimes')

  const openModal = () => {
    if (editType === "tourTimes" || editType === "mealTimes") {
      let timeValues = {
        startTime: editType === "tourTimes" ?
          dayjs.unix(props.detailedSchedule.timeStart).add(props.offset, 'minute')
          : dayjs.unix(props.detailedSchedule.meals[0].mealStart).add(props.offset, 'minute'),
        endTime: editType === "tourTimes" ?
          dayjs.unix(props.detailedSchedule.timeEnd).add(props.offset, 'minute')
          : dayjs.unix(props.detailedSchedule.meals[0].mealEnd).add(props.offset, 'minute'),
      };
      let title = editType === "tourTimes" ? "Edit Tour Times" : "Edit Meal Times";
      props.openModal(
        timeValues,
        editType,
        title,
        props.detailedSchedule.tourId,
        props.offset
      );
    } else {
      props.openModal(
        props.detailedSchedule.comment,
        editType,
        "Edit My Tour Comment",
        props.detailedSchedule.tourId,
        props.offset
      );
    }
  }

  const openAssignModal = (index) => {
    if (editAssignType === "assignTimes") {
      let timeValues = {
        startTime: dayjs.unix(props.detailedSchedule.serviceOrders[index].startDate).add(props.offset, 'minute'),
        endTime: dayjs.unix(props.detailedSchedule.serviceOrders[index].endDate).add(props.offset, 'minute'),
      };

      let ids = {
        serviceId: props.detailedSchedule.serviceOrders[index].serviceId,
        tourId: props.detailedSchedule.serviceOrders[index].tourId,
        jobId: props.detailedSchedule.serviceOrders[index].jobId,
        resourceName: props.resourceName
      }
      props.openModal(
        timeValues,
        editAssignType,
        "Edit Assignment Times",
        ids,
        props.offset
      );
    } else {
      let ids = {
        serviceId: props.detailedSchedule.serviceOrders[index].serviceId,
        tourId: props.detailedSchedule.serviceOrders[index].tourId,
        jobId: props.detailedSchedule.serviceOrders[index].jobId,
        resourceName: props.resourceName
      }
      props.openModal(
        props.detailedSchedule.serviceOrders[index].employeeComment,
        editAssignType,
        "Edit My Assignment Comment",
        ids,
        props.offset
      );
    }
  }

  const handleRadioChange = (e) => {
    setEditType(e.target.value);
  }

  const handleAssignmentRadio = (editAssignType) => {
    setEditAssignType(editAssignType);
  }

  const showEditTourMealButton= () =>{
    return canEdit && ((showTourHours&&props.securityLevels.updateTourHours==3) || (showTourMeals && props.securityLevels.updateMealHours==3) || (showTourComments &&props.securityLevels.myTourComment==3))
  }

  const canEdit = props.canEdit && props.showEdit;
  const isTourApproved = props.detailedSchedule.approved == 1 ? true : false
  const hasAssignments = (props.detailedSchedule.serviceOrders && props.detailedSchedule.serviceOrders.length > 0) ? true : false
  const hasMeals = (props.detailedSchedule.meals && props.detailedSchedule.meals.length > 0) ? true : false
  const hasTour = props.detailedSchedule.tourId > 0 ? true : false
  const isMealApproved = (hasMeals && props.detailedSchedule.meals.approved == 1) ? true : false
  const showTourHours = (props.securityLevels.updateTourHours == 3 && !isTourApproved)&& hasTour ? true : false
  const showTourMeals = (!isTourApproved && !isMealApproved && props.securityLevels.updateMealHours == 3) && hasMeals ? true : false
   let showTourComments = (!isTourApproved)&& hasTour ? true : (props.securityLevels.disableApprovedComments == 3) && hasTour ? true : false
  const nameClass = isTourApproved ? "widget-gray" : ""
  
  useEffect(() => {
    let newEditType = ''
    showTourHours ? newEditType = 'tourTimes'
      : showTourMeals ? newEditType = 'mealTimes'
        : showTourComments ? newEditType = 'myTourComment' : ''
    setEditType(newEditType)
  }, [showTourHours, showTourMeals, showTourComments])

  return (
    <React.Fragment>
      {props.detailedSchedule.tourId > 0 && (
        <>
          {
            showEditTourMealButton() &&
            <div>
              <Radio.Group onChange={handleRadioChange} value={editType}>
                <React.Fragment>
                  {showTourHours && <Radio value="tourTimes">Edit Tour Times</Radio>}
                  {showTourMeals && <Radio value="mealTimes">Edit Meal Times</Radio>}
                  {(props.securityLevels.myTourComment ==3&&showTourComments) && <Radio value="myTourComment">My Tour Comment</Radio>}
                </React.Fragment>
              </Radio.Group>
              {<Button type="primary" onClick={openModal}>Edit Tour/Meal</Button>}
            </div>
          }
          <Descriptions 
          title={'Tour - ' + (dayjs.unix(props.detailedSchedule.timeStart).add(props.offset, 'minute').format('MM/DD/YYYY')) || ""} 
          size='small' 
          style={{ marginBottom: 30 }} 
          bordered>

            <Descriptions.Item label="Start Date" span={3} >
              {dayjs.unix(props.detailedSchedule.timeStart).add(props.offset, 'minute').format('dddd, MMMM Do YYYY') || ''}
            </Descriptions.Item>
            <Descriptions.Item label="End Date" span={3} >
              {dayjs.unix(props.detailedSchedule.timeEnd).add(props.offset, 'minute').format('dddd, MMMM Do YYYY') || ''}
            </Descriptions.Item>
            <Descriptions.Item label="Start Time" span={3} >
              {props.detailedSchedule.startTimeH || ""}
            </Descriptions.Item>
            <Descriptions.Item label="End Time" span={3} >
              {props.detailedSchedule.endTimeH || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Meal Start Date" span={3} >
              {hasMeals ?
                dayjs.unix(props.detailedSchedule.meals[0].mealStart).add(props.offset, 'minute').format('dddd, MMMM Do YYYY') : ""
              }
            </Descriptions.Item>
            <Descriptions.Item label="Meal End Date" span={3} >
              {hasMeals ?
                dayjs.unix(props.detailedSchedule.meals[0].mealEnd).add(props.offset, 'minute').format('dddd, MMMM Do YYYY') : ""
              }
            </Descriptions.Item>
            <Descriptions.Item label="Meal Start Time" span={3} >
              { hasMeals ?
                props.detailedSchedule.meals[0].startTimeH : ""
              }
            </Descriptions.Item>
            <Descriptions.Item label="Meal End Time" span={3} >
               {hasMeals ?
                props.detailedSchedule.meals[0].endTimeH : ""
              }
            </Descriptions.Item>
            {(props.securityLevels.myScheduleCostObject == 2) && <Descriptions.Item label="Cost Center" span={3} >{props.detailedSchedule.costCenter || ''}</Descriptions.Item> }
            {(props.securityLevels.myScheduleCostObject == 2) && <Descriptions.Item label="WBSE" span={3} >{props.detailedSchedule.wbse || ''}</Descriptions.Item> }
            <Descriptions.Item label="Notification Comment" span={3} >{props.detailedSchedule.notification || ''}</Descriptions.Item>
            <Descriptions.Item label="Tour Comment" span={3} >{props.detailedSchedule.comment15 || ''}</Descriptions.Item>
            {(props.securityLevels.myTourComment !=1) && <Descriptions.Item label="My Tour Comment" span={3} >{props.detailedSchedule.comment || ''}</Descriptions.Item>}
            {(props.securityLevels.showRdtCostObject && props.detailedSchedule.rdtCostCenter) && <Descriptions.Item label="RDT Cost Center" span={3} >{props.detailedSchedule.rdtCostCenter || ''}</Descriptions.Item> }
            {(props.securityLevels.showRdtCostObject && props.detailedSchedule.rdtwsbe) && <Descriptions.Item label="RDT WSBE" span={3} >{props.detailedSchedule.rdtwsbe || ''}</Descriptions.Item> }
          </Descriptions>
        </>
      )}

      {hasAssignments && (
        <>
          <DetailedScheduleAssignment
            offset={props.offset}
            detailedSchedule={props.detailedSchedule}
            resourceName={props.resourceName}
            handleAssignmentRadio={handleAssignmentRadio}
            editAssignType={editAssignType}
            openAssignModal={openAssignModal}
            canEdit={props.canEdit}
            securityLevels={props.securityLevels}
            resourcesId={props.resourcesId}
          />
        </>
      )}
    </React.Fragment >
  )

}

export default DetailedScheduleTour;
